export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const UPLOAD_IMAGE_LOADING = 'UPLOAD_IMAGE_LOADING';
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR';
export const RESET_UPLOAD_IMAGE = 'RESET_UPLOAD_IMAGE';
